import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import "./NewDashboardPage.css";
import DashboardSidebar from "../../components/DashboardSidebar/DashboardSidebar";
import useAuthStore from "../../stores/authStore";

const API_URL = process.env.REACT_APP_API_URL;

const NewDashboardPage = () => {
  const { user, setUser, clearUser } = useAuthStore();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // 👇 NEW: sidebar toggle state
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    document.title = "Dashboard | Brandly";
    const fetchUser = async () => {
      try {
        const response = await fetch(`${API_URL}/auth/me`, {
          credentials: "include",
        });

        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
        } else {
          setError(true);
          clearUser();
        }
      } catch (err) {
        setError(true);
        clearUser();
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [setUser, clearUser]);

  const handleRelogin = () => {
    window.location.href = `/login`;
  };

  if (loading) return <div className="dashboard-loading">Checking session...</div>;

  if (error)
    return (
      <div className="dashboard-error">
        <p>Error in login. Please re-login.</p>
        <button className="dashboard-relogin" onClick={handleRelogin}>
          Re-login
        </button>
      </div>
    );

  if (!user) return <div>No user found.</div>;

  const profilePicUrl = user.profile_pic_id || null;

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <DashboardSidebar
        userName={user.name}
        profilePic={profilePicUrl}
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
      />

      {/* Main content */}
      <div className="dashboard-main">
        {/* 👇 Mobile hamburger */}
        <button
          className="hamburger-btn"
          onClick={() => setIsSidebarOpen(true)}
        >
          ☰
        </button>

        <Outlet /> {/* Renders PostGenerator, HookGenerator, etc */}
      </div>
    </div>
  );
};

export default NewDashboardPage;
